import React from 'react'
import { ThemeProvider } from '@mui/material'

import { getTheme } from 'themes'

import EditKpiDialog from 'components_new/organisms/economy/EconomyCustomMetrics/dialogs/EditKpiDialog'
import { parseKpiVariableWithChildren } from 'components_new/organisms/economy/EconomyCustomMetrics/utils'

import { useMetricActions } from 'redux/actions/Metrics'
import { useFetchedKpiVariables } from 'redux/hooks/KpiVariables'
import { useCustomKpis } from 'redux/hooks/Metrics'

import { ICustomEconomyMetric } from 'types/GlobalMetric'

interface MissingDefinitionDialogProps {
  metric: ICustomEconomyMetric
  onClose: () => void
  onSaved?: () => void
}

/** Authors the formula of one custom economy metric in place. */
const MissingDefinitionDialog = (props: MissingDefinitionDialogProps) => {
  const { metric, onClose, onSaved } = props

  const { tryUpdateMetricCalculation } = useMetricActions()

  const [variables, fetchingVariables] = useFetchedKpiVariables()
  const [customKpis] = useCustomKpis()

  if (fetchingVariables) {
    return null
  }

  return (
    <ThemeProvider theme={getTheme('light')}>
      <EditKpiDialog
        formattedVariables={parseKpiVariableWithChildren(variables)}
        kpi={metric}
        open={true}
        onClose={onClose}
        onSave={(body) => {
          tryUpdateMetricCalculation(metric.id, body).then(() => onSaved?.())
          onClose()
        }}
        variables={variables}
        templates={customKpis}
      />
    </ThemeProvider>
  )
}

export default MissingDefinitionDialog
